<template>
  <div class="popup_base">
    <div class="popup" v-click-outside="closePopup">
      <h1>{{ item.name }}</h1>
      <div class="message">{{ t('アカウントを紐づけるため別サイトにログインします。') }}</div>
      <div class="box">
        <div class="row">
          <div class="label">{{ t('メールアドレス') }}</div>
          <div class="text">
            <TextBox maxlength="255" placeholder="" @handleTextInput="changeLoginID($event)" />
          </div>
        </div>
        <div class="row">
          <div class="label">{{ t('パスワード') }}</div>
          <div class="text">
            <TextBox maxlength="30" inputType="password" placeholder="" @handleTextInput="changePassword($event)" />
          </div>
        </div>
      </div>
      <ErrorMessage v-if="errorMessage" class="error-message" :message="errorMessage" />
      <div class="button_area">
        <SquareButton class="square-button2" :text="t('ログイン')" :isMaxWidth="true" @handleSquareBtnClick="goToLogin" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TextBox from '@/components/atoms/TextBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import t from '@/plugins/i18n';

export default {
  name: 'SMSPopup',
  mixins: [t],

  components: {
    TextBox,
    ErrorMessage,
    SquareButton,
  },

  data: () => ({
    errorMessage: '',
    loginid: '',
    password: '',
  }),

  props: {
    item: {
      type: Object,
    },
  },

  computed: {
    ...mapGetters({
      resultLogin: 'otherSite/resultLogin',
    }),
  },

  watch: {
    resultLogin(newVal) {
      if (!newVal.result) {
        window.alert('ログインに失敗しました。\n電話番号も一致している必要があります。');
      } else {
        this.$emit('loginSuccess');
      }
    },
  },

  created() {
    // const postParams = { tel: this.tel };
    // this.$store.dispatch('sms/sendSMS', { postParams });
  },

  methods: {
    goToLogin() {
      const postParams = {
        loginid: this.loginid,
        password: this.password,
        site_id: this.item.id,
      };
      this.$store.dispatch('otherSite/login', { postParams });
    },
    changeLoginID(value) {
      this.loginid = value;
    },
    changePassword(value) {
      this.password = value;
    },
    closePopup() {
      this.$emit('closePopup');
    },
  },
};
</script>

<style lang="scss" scoped>
.popup_base {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;

  .popup {
    background-color: white;
    padding: 60px;
    border-radius: 10px;

    h1 {
      text-align: center;
    }

    .box {
      .row {
        width: 100%;
        margin: 5px 0;
        align-items: center;

        .label {
          width: 120px;
        }

        .text {
          width: calc(100% - 120px);
        }
      }
    }

    .button_area {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      .square-button2 {
        width: 200px;
      }
    }
  }
}

@media screen and (max-width: $tabletWidth) {
  .popup_base {
    .popup {
      padding: 20px;
    }
  }
}
</style>
